import { render, staticRenderFns } from "./TvStationBaseDetail.vue?vue&type=template&id=2d0e5498"
import script from "./TvStationBaseDetail.vue?vue&type=script&lang=js"
export * from "./TvStationBaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports